import React, { FC, RefObject } from 'react'
import ImageUploading, { ImageListType, ImageType } from 'react-images-uploading'
import FbImageLibrary from '../../../FbImageLibrary'

import { TAttachmentIds, TExtendedPostAttachment } from '../../../../store/managePost/newTypes'

import Upload from '../../../UI/Icons/Upload'

import { useDispatch } from '../../../../store/index'
import { removeThumbnailFromAttachmentAction } from '../../../../store/managePost/slice'

import './UI.scss'

// TODO simplify and rename
interface VideoThumbnailProps {
  attachment: TExtendedPostAttachment | null
  isEditable: boolean
  addThumbnailToAttachment: (data: ImageType, ids: TAttachmentIds) => void
  restrictions: any
}

const VideoThumbnail: FC<VideoThumbnailProps> = ({
  attachment,
  addThumbnailToAttachment,
  isEditable,
  restrictions
}) => {
  const dispatch = useDispatch()

  const onChange = (imageList: ImageListType) => {
    if (imageList.length && attachment) {
      addThumbnailToAttachment(imageList[0], {
        id: attachment.id,
        temporaryId: attachment.temporaryId
      })
    }
  }

  const imageRestrictions = restrictions.mediaRestrictions.image

  const removeThumbnail = async (index: number) => {
    if (attachment) {
      const { id, temporaryId } = attachment
      dispatch(removeThumbnailFromAttachmentAction({ id, temporaryId }))
    }
  }

  return (
    <div className='upload-thumbnail'>
      <ImageUploading
        value={[]}
        onChange={onChange}
        dataURLKey='data_url'
        acceptType={imageRestrictions?.valid_file_type}
        maxNumber={restrictions.message.max_mediafiles}
        multiple={false}
      >
        {({ imageList, onImageUpload, dragProps, errors }) => {
          return (
            <div className='upload-thumbnail__wrapper' {...dragProps}>
              {!attachment?.thumbnail_object_data || attachment?.toRemoveVideoTumbnail ? (
                <div className='upload-thumbnail__wrapper__placeholder' onClick={onImageUpload}>
                  <Upload />
                  Add a thumbnail
                </div>
              ) : (
                <div className={`upload-thumbnail__images-wrapper`}>
                  <FbImageLibrary
                    hideOverlay={true}
                    firstImageHeight={100}
                    isEditable={isEditable}
                    images={
                      attachment.thumbnail_object_data && !attachment.toRemoveVideoTumbnail
                        ? [attachment.thumbnail_object_data]
                        : []
                    }
                    onRemove={removeThumbnail}
                  />
                </div>
              )}
              {errors && (
                <div className='upload-thumbnail__wrapper__error'>
                  {errors.maxNumber && (
                    <div className='upload-thumbnail__wrapper__error__item'>
                      Max images quantity for current post type is{' '}
                      {restrictions.message.max_mediafiles}
                    </div>
                  )}
                  {errors.acceptType && (
                    <div className='upload-thumbnail__wrapper__error__item'>
                      Allowed file types is {imageRestrictions?.valid_file_type.join(', ')}.
                    </div>
                  )}
                  {errors.maxFileSize && (
                    <div className='upload-thumbnail__wrapper__error__item'>File is too big</div>
                  )}
                  {errors.resolution && (
                    <div className='upload-thumbnail__wrapper__error__item'>
                      Selected file is not match your desired resolution
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        }}
      </ImageUploading>
    </div>
  )
}

export default VideoThumbnail
